import { createSlice  } from "@reduxjs/toolkit";


interface ITopoState { 
  topoNodeArr: [],
  // selectNodeNameArr:[]
}

const initialState = {
  topoNodeArr: [],//eg:[1,2,3]
  // selectNodeNameArr:[]
} as ITopoState
export const topoNodeSlice = createSlice({
  name:'topoNodeArr',
  initialState,
  reducers: {
    setTopoNodeArr: (state: any, action: any) => { 
      state.topoNodeArr = action.payload;
    //  [...state];
      
    },
    // setSelectNodeNameArr: (state: any, action: any) => { 
    //   state.value = action.payload;
    // }
  }
})

export const { setTopoNodeArr  }:any = topoNodeSlice.actions;
// export const { setSelectNodeNameArr } = rootTopo.actions;
export default topoNodeSlice.reducer;